import { useState } from "react";
import { faqs } from "@/mocks/guaData";

export default function Faq() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100">
      <div className="mx-auto max-w-4xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <p className="flex items-center justify-center gap-2 text-sm font-semibold text-accent-600">
            <span className="flex h-5 w-5 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-question-line text-[13px]"></i>
            </span>
            常见问题
          </p>
          <h2 className="mt-3 text-2xl font-bold text-foreground-950 md:text-4xl">你可能想问的</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">热度怎么算、多久更新、怎样理性吃瓜……都在这里说明白。</p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-lg border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-50" : "border-background-200 bg-background-50/60"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-900"
                    }`}
                  >
                    <i className={`ri-${isOpen ? "subtract" : "add"}-line text-lg`}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-7 text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-8 flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-6 py-6 text-center sm:flex-row sm:justify-between sm:text-left">
          <div>
            <p className="text-base font-semibold text-foreground-950">还有问题没被回答到？</p>
            <p className="mt-1 text-sm text-foreground-600">把你想了解的写给我们，编辑部会尽快回复你。</p>
          </div>
          <a
            href="mailto:hi@guachangbang.example"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-mail-line text-[15px]"></i>
            </span>
            联系我们
          </a>
        </div>
      </div>
    </section>
  );
}